import React from "react";
import "./style.css";

const Photo = ({ url, visibility = true }) => {
  if (visibility) {
    return <img className="photo-grid-item" alt="" src={url} />;
  }

  return <img className="photo-grid-item-hidden" alt="" src={url} />;
};

export default Photo;
